import PropTypes from 'prop-types';
import React from 'react';
import Carousel from 'nuka-carousel';
import { CarouselNext, CarouselPrev } from '../Carousel/Controls';
export var ResponsiveCarouselLg = function ResponsiveCarouselLg(_ref) {
  var children = _ref.children,
      extraClass = _ref.extraClass,
      handleSlide = _ref.handleSlide,
      loading = _ref.loading;

  if (loading || !children || !children.length) {
    return false;
  }

  return React.createElement(Carousel, {
    afterSlide: handleSlide,
    className: extraClass,
    cellAlign: "left",
    cellSpacing: children.length > 1 ? 10 : 0 // workaround for https://github.com/FormidableLabs/nuka-carousel/issues/234
    ,
    decorators: [{
      component: CarouselPrev,
      position: 'TopLeft'
    }, {
      component: CarouselNext,
      position: 'TopRight'
    }],
    dragging: false,
    edgeEasing: "easeOut",
    speed: 150,
    slidesToShow: 4,
    slidesToScroll: 4,
    width: "100%"
  }, children);
};
ResponsiveCarouselLg.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  extraClass: PropTypes.string,
  handleSlide: PropTypes.func,
  loading: PropTypes.bool
};